import React from 'react';

export function BulkUploadPendingChanges({ pendingDeletes, pendingEdits, rowsLength }) {
    return (
        <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <span>
                {rowsLength} row{rowsLength !== 1 ? 's' : ''}
            </span>
            {pendingDeletes.size > 0 && (
                <span className="text-destructive">{pendingDeletes.size} marked for deletion</span>
            )}
            {Object.keys(pendingEdits).length > 0 && (
                <span className="text-yellow-600">
                    {Object.keys(pendingEdits).length} row
                    {Object.keys(pendingEdits).length !== 1 ? 's' : ''} edited
                </span>
            )}
        </div>
    );
}
